import React from 'react';
import { memo } from 'react';

import {
  FeatureContainer,
  FeatureOptionsContainer,
  FeatureTitle,
  LabelsContainer,
  TitleContainer,
} from './Labels.style';
import PhaseOption from './PhaseOption';

interface LabelsProps {
  activeFrame: any;
  phaseClasses: any;
  dicom: any;
  phaseLabels: any;
  setPhaseLabel: any;
}

const Labels = ({ activeFrame, phaseClasses, dicom, phaseLabels, setPhaseLabel }: LabelsProps) => {
  const phaseLabelOptions = phaseClasses?.map((cardiacPhase, index) => {
    const phaseLabel = phaseLabels?.find(
      phaseLabelLabel => phaseLabelLabel?.phaseClass === cardiacPhase?.value
    );
    return (
      <PhaseOption
        key={index}
        activeFrame={activeFrame}
        cardiacPhase={cardiacPhase}
        dicom={dicom}
        phaseLabel={phaseLabel}
        setPhaseLabel={setPhaseLabel}
      />
    );
  });

  return (
    <LabelsContainer>
      <TitleContainer>Set Phases</TitleContainer>
      <FeatureContainer>
        <FeatureTitle>Phase</FeatureTitle>
        <FeatureOptionsContainer>{phaseLabelOptions}</FeatureOptionsContainer>
      </FeatureContainer>
    </LabelsContainer>
  );
};

export default memo(Labels);
